import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import SubscriptionPlanListPage from './subscription-plan-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="SubscriptionPlans">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>            
            <Breadcrumb.Item active>Subscription Plans</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <SubscriptionPlanListPage />
    </Panel>
  );
};

export default Page;
